<!--
 * @Description: ================== 隐私政策 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Privacy.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-13 10:21:04
-->
<template>
  <div class="page page-game">
    <h2 class="title">隐私政策</h2>
    <pre>      本文是由广州市故笙科技有限公司（以下简称“我们”）根据《中华人民共和国网络安全法》《信息安全技术个人信息安全规范》以及其他相关法律法规和技术规范，更新了《隐私保护政策》（以下简称“本《隐私政策》”）的相关内容。您在使用我们的服务时，我们可能会收集、储存、使用和分享您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、储存、使用和分享这些信息、我们为您提供的访问、更新、控制和保护这些信息的方式，以及您所享有的有关权利等。本《隐私政策》与您所使用的我们服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
      如对本《隐私政策》或相关事宜有任何问题，请与我们联系。
      本《隐私政策》目录：
      一、 我们可能收集的信息
      二、 我们会出于以下目的，收集和使用您的以下个人信息
      三、 我们如何使用Cookie 和同类技术
      四、 我们接入的第三方服务
      五、 我们可能向您发送的邮件和信息
      六、 我们可能共享、转让、披露您的信息
      七、 我们如何保护和存储您的信息
      八、 您如何管理您的信息
      九、 未成年人使用我们的服务
      十、 隐私政策的适用范围
      十一、 法律、储存期限
      十二、 本政策如何更新
      十三、账号注销
      十四、 如何联系我们
      请在使用或继续使用我们的服务前，仔细阅读并了解本《隐私政策》。

<div style="margin: 20px 0 15px 0; padding: 12px 16px; border-left: 4px solid #d32f2f; background-color: #fff8f8; font-size: 14px; line-height: 1.6; color: #333;">
  <strong style="color: #d32f2f; display: block; margin-bottom: 8px;">重要提示：敏感个人信息的处理情况及保护措施</strong>
  根据《中华人民共和国个人信息保护法》及《信息安全技术 个人信息安全规范》（GB/T 35273-2020）第3.2条及附录B之规定，个人敏感信息系指一旦泄露、非法提供或滥用，极易导致个人信息主体人身财产安全受损、名誉或身心健康遭受严重侵害，或引发歧视性待遇的个人信息。本应用实际处理的个人敏感信息包括但不限于：

 <strong style="color: #d32f2f;">1. 个人身份信息</strong>：自然人姓名、居民身份证件号码、户口簿等身份证明文件信息（用于实名身份核验）；
 <strong style="color: #d32f2f;">2. 账号鉴别信息</strong>：账号密码（含口令、鉴别信息）（用于注册、登录及账号安全保障）；
 <strong style="color: #d32f2f;">3. 个人财产信息及交易信息</strong>：充值记录、消费记录、支付流水、虚拟财产信息（含游戏兑换码、虚拟物品、虚拟交易记录）（用于支付结算及虚拟财产保护）；
 <strong style="color: #d32f2f;">4. 14岁以下（含）未成年人个人信息</strong>（依法采取严格保护措施）；
 <strong style="color: #d32f2f;">5. 通信内容信息</strong>：用户通过文字、图片、语音、视频等方式产生的互动内容（用于内容审核及违法有害信息过滤）；
 <strong style="color: #d32f2f;">6. 位置信息</strong>（用于服务提供、个性化推荐及广告投放等）；
 <strong style="color: #d32f2f;">7. 设备唯一标识信息</strong>：IMEI、Android ID、OAID、MAC地址等终端设备标识（用于账号安全风控及异常登录检测）。
 <strong style="color: #d32f2f; display: block; margin-top: 10px;">本应用对上述个人敏感信息采取加密存储、加密传输、最小化处理、访问控制等安全措施，仅限于实现本隐私政策所述特定目的。如个人信息主体拒绝提供上述敏感信息，可能导致无法正常使用实名认证、支付结算、语音互动等核心功能。</strong>
</div>

      一、 我们可能收集的信息

      我们及所使用的SDK将通过以下途径收集和获取您的个人信息：
      1、您提供的信息。例如：
      （1）您在注册我们的帐号或使用我们提供的产品或服务时，向我们提供的信息。
      （2）您上传/发布的信息：当您使用我们的虚拟社区分享功能时，您上传的文字、照片、评论、点赞等信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时查询、更正、删除这些信息。
      2、第三方共享的您的信息。即第三方使用我们的服务时所提供有关您的共享信息。
      3、我们获取的您的信息。您在使用我们的产品或服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息。

      二、我们及所使用的SDK会出于以下目的，收集和使用您的以下个人信息：

      （一）帮助您完成注册和登录
      为便于我们为您提供持续稳定的服务并保障您使用服务过程中的安全性，我们需要您提供基本注册和登录信息，包括账号密码（包括口令）、移动电话号码等，以便我们帮助您完成注册及登录。
      您使用第三方账号（即我们认可的、可用于登录我们游戏的其他第三方账号，比如微信）登录我们游戏时，我们将收集您登录时所使用的第三方账号头像和昵称、日期、时间标识、登录日志，以及您在使用我们服务过程中的服务内容、物品日志，用于保存您的登录信息，核验您账号的安全性，以便您可以在不同设备登录。
      您也可以在注册、登录或后续使用过程中，自主选择是否填写或补充您的其他额外信息，比如您的头像、邮箱、地区、生日、性别、职业，这将有助于我们进行数据分析，但如果您不提供这些信息，并不会影响您使用我们服务的基本功能。
      （二）实现身份认证
      依照相关法律法规规定及监管要求，为满足用户身份真实核验、保障系统和服务安全及其他特定服务功能等需要，我们可能需要您提供真实身份信息（例如姓名、身份证、户口簿）以完成身份认证，该信息属于敏感信息。如果您不提供上述信息，将导致您无法登录我们游戏或在使用我们游戏过程中受到相应限制。
      为实现身份认证的目的，您同意并授权我们可能以自行或委托第三方向有关身份认证机构（如个人征信机构、政府部门等）提供、查询、核对您的上述身份信息。
      （三）完成支付和消费
      当您使用我们的消费功能时，我们会收集您的充值记录、消费记录等信息，以便提供服务并允许您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感信息，收集上述信息为实现我们产品的消费功能所必需，否则将无法完成交易。
      （四）维护功能的正常运行，保障账号安全
      为了您能够查看您的游戏历史记录，同时用于游戏运营统计分析、客服投诉处理及其他游戏安全分析，了解产品适配性、识别账号异常状态，保障服务的网络及运营安全性，您使用服务过程中，我们可能会直接或者间接地收集、存储关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
      1、 日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动收集您对我们服务的详细使用情况，作为有关网络日志保存，例如：您的登录帐号、IP地址、电信运营商、网络环境、使用的语言、访问日期和时间等。
      2、设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的设备配置信息（如设备ID、设备名称、设备类型、硬件序列号、设备MAC地址、应用ID、网络类型、网络端口信息、应用程序版本、应用设置），您的 IP 地址和移动设备所用的系统版本和设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息），以及您设备的OAID（即移动安全联盟联合国内手机厂商推出的补充设备标识，用以满足用户行为统计），以便我们识别不同用户，保障您正常使用我们的服务，维护游戏基础功能的正常运行，优化游戏产品性能，提升您的游戏体验并保障您的账号安全。
      为了收集上述个人设备或软件信息，我们将会申请访问您的设备信息的权限，您可以通过授权方式同意或者不同意我们收集上述信息。我们收集这些信息是为了标识您使用的设备，用于防止异常登录和账号找回，以保障您的账号安全。
      您可以通过移动设备的设置功能，主动关停我们对您的上述设备或软件信息的收集。
      3、您在游戏账号中的昵称、头像，您对我们软件的使用记录、点击记录以及您在我们中的相关操作信息、游戏信息（比如您的登录状态、对战信息/状态、成就信息等）、游戏事件信息（如错误、崩溃、重启、升级），以及您设备安装的应用信息和运行的进程信息，我们收集上述信息用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊、预防病毒和木马等恶意程序），保障您的游戏账号安全，营造公平、健康及安全的游戏环境；
      （五）提供互动与发布服务
      您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等，我们将收集您上传、发布或形成的信息，以便您能查看分享内容历史记录。
        当您在游戏中通过文字、图片、语音、视频及其他方式与其他玩家进行互动，我们可能会收集并保存您发送的上述信息内容用于过滤政治、色情、暴力、辱骂、恶意广告等不当内容并向有关部门报告，以此净化游戏环境，维护健康的上网环境。
      请注意，您公开发布的信息中可能包含您的个人信息或个人敏感信息，请您在发布前慎重考虑。如您发布的信息涉及到他人的个人信息的，您应当在发布前征得他人同意。
      （六）提供客户服务和其他用户响应功能
      当您联系我们的客服或使用其他用户响应功能时（例如投诉或建议、其他客户投诉和需求），我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的账号与虚拟物品安全。我们可能会保存与您的通信/通话记录和内容、您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、与您的需求相关联的其他信息（用以证明您身份的信息），以便我们与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
      （七）提供安全保障
      为提高您使用我们及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或我们服务相关协议规则的情况，我们可能会收集、使用或整合您的账号信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
      （八）您理解并同意，部分单项服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及信息的收集和使用，例如：
      1、在您开启存储权限后，您允许我们访问您的存储空间，以便使您可以下载并保存内容，或者通过缓冲实现相关功能，以及出现异常时恢复游戏数据。需要特别说明的是，为实现下载文件或大量资源的游戏场景的功能，您同意我们读取和写入您的设备的外置存储器；
        2、在您开启设备信息权限后，您允许我们在使用状态或在后台状态时获取您的设备信息（如IMEI，Android ID等）以作为您设备的唯一性标识，用于标识您使用的设备，用于防止异常登录和账号找回，以保障您的账号安全；
        3、在您开启相机（摄像头、相册）权限后，您能够拍摄、上传图片，实现发布信息和评论或与客服沟通提供证明等功能；
        4、在您开启麦克风权限后，您能够使用游戏内语音聊天和频道语音功能；
        5、获取运行进程，用于广点通SDK转化归因用户数据采集
      我们不会主动开启上述功能权限，您需要主动申请并授权我们之后，您才能使用相关功能。
      当您需要关闭上述功能权限时，大多数移动设备都会支持您的这项需求，一般在设备的“设置”功能中可以加以关闭，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
      需要特别说明的是，某些信息因其特殊性可能被认为是个人敏感信息，例如您的姓名、身份证、个人电话号码、账号密码（包括口令）、银行账号、交易和消费记录、虚拟交易、游戏类兑换码等虚拟财产信息、14岁以下（含）未成年人的个人信息等。相比其他信息，个人敏感信息受到更加严格的保护。请您谨慎并留意个人敏感信息，您同意我们可以按本政策所述的目的和方式来处理您的个人敏感信息。
      请注意，您在使用我们的服务时向其他用户或公开提供、上传或发布、分享的内容和信息，可能会泄露您的个人敏感信息。您需要谨慎地考虑，是否向其他用户披露相关个人敏感信息 。
      如您不同意按本《隐私政策》所述的目的和方式来处理您的个人信息，请拒绝提供，但请理解，如拒绝提供部分信息，可能导致您无法使用我们提供该信息所对应的部分服务。
      请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。

      五、 我们可能向您发送的邮件和信息

      （一）您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻、短信或推送通知。如您不希望收到这些信息，可以通过设备的“设置”功能，在设备上选择取消订阅。
      （二）我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。

      六、 我们可能共享、转让、披露您的信息

      （一） 共享
      除以下情形和目的外，未经您同意，我们不会与任何第三方共享我们收集的您的信息：
      1、获得您的同意后，我们会与其他方共享您的信息；
      我们可能会根据法律法规规定，或按政府主管部门的强制性要求，或按行政、司法机关依法提出的要求，对外共享您的信息；
      2、 与关联方的必要共享：为便于我们基于统一的帐号体系向您提供一致化服务以及便于您进行统一管理、保障系统和帐号安全，或保护我们关联公司或其他用户或公众的人身财产安全免遭侵害，您的信息可能会与我们的关联方共享 。我们只会出于特定、明确而合法的目的共享必要的信息（如为便于您使用我们账号登陆、使用大道 游戏旗下其他产品和服务，我们会向大道 游戏旗下其他游戏或者关联方共享您必要的账户信息），并保证关联方承担与我们同等的保密义务。如果关联方改变信息的使用及处理目的，将再次征求您的授权同意；
      3、 与授权合作伙伴共享：为确保顺利地为您提供服务，我们以及我们的关联公司，可能将您的信息在去标识化处理后（因进行实名认证向行政主管部门或类似用途的第三方验证机构提供您的实名身份信息的情形除外，在此情况下我们将采取一切合理、必要、有效的手段，保障您个人信息的安全，并要求第三方验证机构承担严格的保密义务），与我们及我们关联公司的合作伙伴、第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、提供支付的支付机构、数据服务商（包括网络广告监测、数据统计、数据分析）的合作伙伴）分享（他们可能并非位于您所在的法域）。上述合作伙伴可能将信息用作下列用途：
      （1） 向您提供我们的服务，确保您能正常使用所需要的服务，比如实现游戏内支付功能；
      （2）广告数据检测和投放，了解我们服务的受众或顾客，以便我们提升和维护服务质量；
      （3） 实现本《隐私政策》第二条部分所述目的；
      （4） 履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利。
      我们仅出于合法、正当、必要、特定、明确的目的共享您的信息，并且只会共享并提供服务所必要的信息。
      （二） 转让
      1、 在获得您的明确同意后，我们会向其他方转让您的信息；
      2、 随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则，我们将要求该公司、组织重新向您征求授权同意。
      （三） 披露
      根据法律要求，或者我们有充分的理由认为披露是合理必要的，我们也可能会保留或披露您的信息 ：
      1、 遵守适用的法律法规；
      2、 遵守司法机关要求或其他法律程序的规定；
      3、 遵守相关政府机关的要求；
      4、 为了履行我们的服务协议和其他协议、政策和标准，包括调查任何可能的违规行为；
      5、 为了检测、预防或以其他方式解决安全、欺诈或技术问题；
      6、为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
      （四） 共享、转让、披露信息时事先征得授权同意的例外
      以下情形中，共享、转让、公开披露您的信息无需事先征得您的授权同意：
      1、与国家安全、国防安全有关的；
      2、与公共安全、公共卫生、重大公共利益有关的；
      3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
      4、出于维护您或其他个人的生命、财产等重大合法权益有关的；
      5、您自行向社会公众公开的信息；
      6、从合法公开披露的信息中收集的信息，如合法的新闻报道、政府信息公开等渠道。
      根据法律规定，共享、转让、披露经去标识化处理的信息，且确保数据接收方无法复原并重新识别信息主体的，不属于信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。

      七、 我们如何保护和存储您的信息

      1、安全保护措施
      （1）我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。 此外，我们游戏的相关系统还通过了国家网络安全等级保护（三级）的备案和测评。
      （2）我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作， 以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。
      （3）我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
      2、安全事件处置措施
      若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
      3、安全提示
      请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。
      请您务必妥善保管好您的账号、密码及其他身份要素。您在使用我们服务时，我们会通过您的账号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现账号、密码及/或其他身份要素可能或已经泄露时， 请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。
      我们在中国境内运营过程中收集和产生的个人信息将保存在中国境内 (为本隐私政策之目的，“中国境内”不含中国港澳台地区)
      （五） 注销您的信息
      1、 您可以通过联系我们的客服或我们公开的方式提交账户注销申请。
      2、 但请注意，在注销账户之后，我们将停止为您提供服务，并在符合法律规定的前提下删除您的信息，或将其匿名化处理。
      3、账户注销之后不可找回，并且您将无法继续使用该账号登录我们旗下任何一款游戏，亦无法继续使用我们所提供的服务；您理解，为避免不必要的重复注销或造成其他用户的混淆和误认，我们将在12个月内锁定您所注销的账号名称，在此期间，您将无法重新注册相同的账号名称，因此请您慎重选择是否申请注销账户。
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行管理）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      在以下情形中，按照法律法规要求，我们将无法响应您的请求：
      1、 与国家安全、国防安全直接相关的；
      2、 与公共安全、公共卫生、重大公共利益直接相关的；
      3、 与犯罪侦查、起诉、审判和判决执行等司法活动或行政执法直接相关的；
      4、 有充分证据表明您存在主观恶意或滥用权利的；
      5、 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      6、 涉及商业秘密的；
      7、与我们履行法律法规规定的义务相关的。

      九、 未成年人使用我们的服务

      （一） 我们建议：任何未成年人参加网上活动应事先取得家长或其法定监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关信息。
      （二） 我们鼓励父母或监护人指导未成年人使用我们的服务。未成年人的父母或监护人应阅读本《隐私政策》，当发现未成年人过于沉迷时，父母或监护人可通过“未成年人家长监护工程”申请家长监护服务。
      （三）如果您是14周岁以下（含）未成年人，请通知您的父母或监护人阅读本政策，并在您提交个人信息之前，寻求父母或监护人的同意和指导。

      十、 隐私政策的适用范围

      （一） 除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。
      （二） 请您注意，本《隐私政策》不适用于以下情况 ：
      1、 通过我们的服务而接入、跳转的第三方服务（包括任何第三方网站）收集的信息；
      2、 通过在我们服务中接入的第三方服务商SDK所收集的信息。
      上述第三方收集信息的具体情况，请详见各运营方公示的隐私政策和相关声明。
      （三）征得授权同意的例外
      根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：
      （1）与国家安全、国防安全有关的；
      （2）与公共安全、公共卫生、重大公共利益有关的；
      （3）与犯罪侦查、起诉、审判和判决执行等有关的；
      （4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      （5）所收集的信息是您自行向社会公众公开的；
      （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
      （7）根据您的要求签订合同所必需的；
      （8）用于维护我们服务的安全稳定运行所必需的，例如发现、处置服务的故障；
      （9）为合法的新闻报道所必需的；
      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
      （11）法律法规规定的其他情形。
      （四）隐私政策的适用例外
      我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：
      1、 您利用分享功能将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；
      2、 我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
      该等第三方社交媒体或其他服务可能由相关的第三方运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非通用条款（如《我们使用许可及服务协议》）或本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息或收集您的信息不承担任何责任。

      十一、 法律、储存期限

      本《隐私政策》适用中华人民共和国的法律，并且排除一切冲突法规定的适用。我们将按照相关法律法规规定的期限储存您的个人信息。超过相关法律法规规定的期限后，如您未联系我们删除您的个人信息，我们将采取一切合理、必要、有效的手段，继续保障您个人信息的安全。

      十二、 本政策如何更新

      我们的隐私政策可能变更。
      我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如修改本《隐私政策》的，我们将通过在主页上专门页面或位置提示或以其他方式通知您。

      十三、 账号注销       账号注销请您按以下流程操作       （1）请提供需要注销账号的准确信息；       （2）请提供帐号所绑定的身份信息；       （3）注意：如您登录游戏使用的账号为渠道账号，请前往对应渠道应用商店或游戏中心相应模块进行注销       请您将以下信息发送至邮箱：gsgame666@163.com，我们将会在1-7个工作日内回复处理       【提交申请模板】：       1、邮件标题：手游账号注销-XXX(账号)       2、邮件内容：所在游戏；账号；角色名；服务器；绑定手机号；密保邮箱；密保问题；充值记录截图；注册地点；常用登录地点；帐号所绑定的身份信息

      十四、 如何联系我们

      如果您对本隐私政策有任何疑问、意见或建议，或需要就您的个人信息安全进行投诉、举报的， 您可以通过我们客服与我们联系。一般情况下，我们将在验证您的身份信息后十五个工作日内回复。
      如果您对我们的回复不满意，特别是您认为我们的信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：您可以通过向被告所在地有管辖权的人民法院提起诉讼的方式来寻求解决方案。

      《游戏接入第三方SDK列表》

      为保障特定功能的实现，第三方服务商提供的软件开发包（SDK）或类似应用程序实现相关目的。我们将对相关SDK或应用程序进行安全检查，以确保您个人信息的安全。我们接入的第三方服务商服务商详见下表：

        SDK名称：合作游戏SDK
        开发者：广东欢太科技有限公司
        包名：com.nearme.game.sdk
        收集个人信息用途/目的：联运合作SDK是OPPO提供的一个开发工具包，被集成于游戏中，为用户提供登录游戏、支付、游戏福利、游戏内容等服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&amp;actId=10001811&amp;c=0

        SDK名称：OPPO PUSH 客户端SDK
        开发者：广东欢太科技有限公司
        包名：com.heytap.msp
        收集个人信息用途/目的：提供给到外部业务的进行集成的SDK，业务通过该SDK实现离线消息的推送能力。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://open.oppomobile.com/new/developmentDoc/info?id=11228

        SDK名称：OPPO联盟广告SDK
        开发者：广东欢太科技有限公司
        包名：com.heytap.msp.mobad.api
        收集个人信息用途/目的：提供广告服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://u.oppomobile.com/main/privacy.html

        SDK名称：vivo联运SDK
        开发者：维沃移动通信有限公司
        包名：com.vivo.unionsdk
        收集个人信息用途/目的：游戏联运SDK是vivo官方开发的功能插件，用于为用户在游戏内提供支付安全，账号服务等功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://dev.vivo.com.cn/documentCenter/doc/712

        SDK名称：vivo PUSH-SDK
        开发者：维沃移动通信有限公司
        包名：com.vivo.push
        收集个人信息用途/目的：vivo推送（即Vpush）是vivo公司向开发者提供的消息推送服务，通过在云端与客户端之间建立一条稳定、可靠的长连接，为开发者提供向客户端应用实时推送消息的服务，支持百亿级的通知/消息推送，秒级触达移动用户。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://dev.vivo.com.cn/documentCenter/doc/652

        SDK名称：广告SDK（联盟）
        开发者：维沃移动通信有限公司
        包名：com.vivo.mobilead
        收集个人信息用途/目的：提供广告展示功能，通过使用广告SDK，第三方App提供者可以在App中展示广告商投放的广告，进而根据最终用户的点击赚取收益。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://adnet.vivo.com.cn/home/agreement/18

        SDK名称：HMSCore-Base-SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.android.hms.base
        收集个人信息用途/目的：集成至业务SDK和开发者的应用中，为开发者应用连接HMS Core提供基础服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050121546

        SDK名称：华为游戏服务 SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.android.hms.game
        收集个人信息用途/目的：游戏服务是华为提供的能够快速开发游戏应用的服务，游戏服务是华为提供的能够快速开发游戏应用的服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050121546

        SDK名称：华为帐号SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.hms.account
        收集个人信息用途/目的：通过华为帐号开放服务，Android应用可以方便、安全地实现快速登录授权、独立授权等功能，凭借用户授权凭证，应用可快速访问调用华为提供的公开API。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-forandroid-0000001695031596

        SDK名称：华为应用内支付SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.hms.pay
        收集个人信息用途/目的：开发者App通过集成IAP SDK，再调用IAP SDK接口启动IAP收银台，实现应用内支付。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906

        SDK名称：华为分析SDK Android
        开发者：华为软件技术有限公司
        包名：com.huawei.hms.analytics
        收集个人信息用途/目的：华为分析服务（Analytics Kit）是针对移动应用、Web、快应用、快游戏、小程序等产品的一站式用户行为分析平台，贴合业务场景，提供数据采集、数据管理、数据分析、数据应用的一体化解决方案，驱动企业实现精准拉新、产品优化、精益运营、业务增长。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/android-sdk-data-security-0000001050745153

        SDK名称：华为推送SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.android.hms.push
        收集个人信息用途/目的：推送服务（Push Kit）是华为提供的消息推送平台，建立了从云端到终端的消息推送通道。您通过集成推送服务，可以向客户端应用实时推送消息，构筑良好的用户关系，提升用户的感知度和活跃度。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177

        SDK名称：鲸鸿动能SDK
        开发者：华为软件技术有限公司
        包名：com.huawei.hms.ads
        收集个人信息用途/目的：HUAWEI Ads流量变现服务（HUAWEI Ads Publisher Service，以下简称为流量变现服务）是广告服务依托华为终端强大的平台与数据能力为您提供的App流量变现服务，您通过该服务可以在自己的App中获取并向用户展示精美的、高价值的广告内容，并从中获得广告收益。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582

        SDK名称：荣耀游戏联运SDK
        开发者：深圳荣耀软件技术有限公司
        包名：com.hihonor.gamecenter.gamesdk.sdk
        收集个人信息用途/目的：游戏联运SDK是一款为荣耀和开发者在荣耀游戏中心进行游戏的联合运营，并进行分成的合作服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.honor.com/cn/docs/game_center/guides/jieruzhinan/sdkyinsi

        SDK名称：荣耀应用内支付SDK
        开发者：深圳荣耀软件技术有限公司
        包名：com.hihonor.iap.sdk
        收集个人信息用途/目的：荣耀应用内支付（In-App Purchases，即 IAP）是一种为 APP 提供支付能力的服务，拥有简洁的接入流程，让应用内支付更加便捷。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.honor.com/cn/docs/11017/guides/privacy

        SDK名称：荣耀推送SDK
        开发者：深圳荣耀软件技术有限公司
        包名：com.hihonor.push
        收集个人信息用途/目的：荣耀推送服务（HONOR Push）是荣耀公司向开发者提供的消息推送服务，通过服务端与客户端建立一条稳定、可靠的长连接通道，向荣耀手机系统上的APP应用客户端实时推送消息的服务。无论应用进程是否存在，均可正常收到消息。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.honor.com/cn/docs/11002/guides/sdk-data-security

        SDK名称：荣耀广告SDK
        开发者：深圳荣耀软件技术有限公司
        包名：com.hihonor.adsdk
        收集个人信息用途/目的：荣耀广告SDK为开发者提供优质的流量变现服务，帮助开发者实现商业增长。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.honor.com/cn/docs/20030/guides/sdk-privacy-statement

        SDK名称：小米游戏联运 SDK
        开发者：北京瓦力网络科技有限公司
        包名：com.xiaomi.gamecenter.sdk
        收集个人信息用途/目的：小米联运SDK是小米公司向游戏开发者提供的游戏服务插件。通过SDK，可以向游戏用户提供登录、支付、实名制及防沉迷功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤手机通讯录；
        SDK隐私政策链接： https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1402

        SDK名称：小米游戏服务
        开发者：北京瓦力网络科技有限公司
        包名：com.xiaomi.gamecenter.sdk
        收集个人信息用途/目的：为用户提供登录游戏以及支付订单功能。
        收集个人信息类型：设备信息（Android ID、OAID）、网络信息（网络可用状态、networkCountryIso、 wifi的IP地址、SSID、BSSID）、应用信息（应用包名、版本号）、用户身份信息（身份证号、姓名、手机号、证件照片）
        SDK隐私政策链接： https://privacy.mi.com/xiaomigame-sdk/zh_CN/

        SDK名称：小米推送
        开发者：北京小米移动软件有限公司
        包名：com.xiaomi.push
        收集个人信息用途/目的：小米推送（MiPush）是小米公司向开发者提供的消息推送服务，通过在云端与客户端之间建立一条稳定、可靠的长连接，为开发者提供向客户端应用实时推送消息的服务，有效地帮助开发者触达用户，提升APP活跃度。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://dev.mi.com/console/doc/detail?pId=1822

        SDK名称：米盟聚合广告SDK
        开发者：深圳小米信息技术有限公司
        包名：com.xiaomi.ad.mediation
        收集个人信息用途/目的：①展示广告的服务；
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1688

        SDK名称：bilibili游戏SDK
        开发者：上海幻电信息科技有限公司
        包名：com.gsc.pub
        收集个人信息用途/目的：为第三方游戏开发商提供登录、支付功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://game.bilibili.com/agreement/privacy/2/628f25c2fb3ee100426c1095?fromOpenUri=0&amp;isOwnLink=1&amp;aloneBack=1&amp;alone=1

        SDK名称：抖音openSDK（安卓版）
        开发者：北京微播视界科技有限公司
        包名：com.bytedance.sdk.open.douyin
        收集个人信息用途/目的：抖音SDK提供抖音登录、授权以及分享至抖音的基本能力。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.open-douyin.com/docs/resource/zh-CN/dop/operation-standard/service-protocol/douyinsdk_pingtaiyinsizhengce

        SDK名称：抖音SDK（安卓版）
        开发者：北京微播视界科技有限公司
        包名：com.bytedance.android.dy.sdk
        收集个人信息用途/目的：抖音SDK ，作为抖音开放平台行业解决方案之一，以抖音内容为依托，以 SDK 为载体，支持外部应用组件化接入视频及直播能力，通过接入该 SDK，实现用户在第三方 App 观看抖音内容，进行互动送礼，电商下单交易的同时也为开发者提供在第三方应用及设备一键开播的能力，通过在自身应用内开直播间并分发至抖音，提升用户活跃时长和用户留存，助力自身业务完成流量转化升级，转化流量价值。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.open-douyin.com/docs/resource/zh-CN/dop/operation-standard/service-protocol/douyin-sdk-privacy-policy

        SDK名称：233乐园内购SDK
        开发者：北京龙威互动科技有限公司
        包名：com.meta.android.mpg
        收集个人信息用途/目的：为接入的游戏提供233乐园账户登录、实名认证、防沉迷、充值、更新、游戏内容展示等功能
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://doc.233leyuan.com/protocol/233乐园内购SDK隐私政策.html

        SDK名称：233乐园广告SDK
        开发者：北京龙威互动科技有限公司
        包名：com.meta.android.mpg.cm
        收集个人信息用途/目的：提供广告变现的服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://doc.233leyuan.com/protocol/233%E4%B9%90%E5%9B%AD%E5%B9%BF%E5%91%8ASDK%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.html

        SDK名称：手游运营SDK
        开发者：四三九九网络股份有限公司
        包名：cn.m4399.operate
        收集个人信息用途/目的：为手游提供登录防沉迷、充值、论坛、客服、违规举报、手机绑定、修改密码、注销账号、游戏升级更新等一系列功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://ptlogin.4399.com/resource/protocol.html?type=2&amp;aids=4,10

        SDK名称：4399聚合广告SDK
        开发者：四三九九网络股份有限公司
        包名：com.mob4399.adunion
        收集个人信息用途/目的：为手游提供广告变现的服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://ptlogin.4399.com/resource/protocol.html?type=2&amp;aids=8

        SDK名称：魅玩联运SDK
        开发者：湖北星纪魅族信息技术有限公司
        包名：com.meizu.gamesdk
        收集个人信息用途/目的：Flyme账号快速登录游戏，支持多账号切换，方便快捷。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://open.mlinkapp.com/docs?id=233

        SDK名称：咪咕云游戏CP SDK
        开发者：咪咕互动娱乐有限公司
        包名：com.migugame.cpsdk
        收集个人信息用途/目的：咪咕云游戏 CP SDK，为移动应用提供一个完善的云游戏交互系统解决方案，以及登录、 支付及广告能力对接、实名认证&amp;防沉迷、游戏上报竞技排行、设置视频彩铃、文字聊天等功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://passport.migu.cn/portal/privacy/protocol?sourceid=206045

        SDK名称：三星
        开发者：北京鹏泰博兴科技有限公司
        收集个人信息用途/目的：①向用户提供登录和支付服务；②向用户展示广告内容；
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.samsung.com/semiconductor/minisite/exynos/cn/privacy-global/

        SDK名称：TapSDK
        开发者：易玩（上海）网络科技有限公司
        包名：com.taptap.sdk.core
        收集个人信息用途/目的：TapSDK 是我们提供的众多服务的总称，为了方便开发者按需接入，我们将每一个子服务使用一个独立模块来对外提供服务。例如： TapTap 登录 对应 TapLogin 模块， 更新唤起 对应 TapUpdate模块等。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://developer.taptap.cn/docs/sdk/start/agreement/

        SDK名称：TapADN SDK
        开发者：上海艾得蒽数字科技有限公司
        包名：com.tapsdk.tapad
        收集个人信息用途/目的：TapADN SDK 向媒体提供丰富的广告资源，依托高效的算法引擎，帮助开发者实现流量变现。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://ssp.dirichlet.cn/docs/agreement/

        SDK名称：九游SDK
        开发者：广州爱九游信息技术有限公司
        包名：cn.uc.gamesdk
        收集个人信息用途/目的：九游游戏SDK是广州爱九游信息技术有限公司推出的基于游戏联运业务的面向开发者的开发SDK，SDK集成了登录、支付的一站式服务，为游戏用户提供游戏登录、支付服务支撑。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://open.9game.cn/ngprivacy

        SDK名称：九游广告SDK
        开发者：广州爱九游信息技术有限公司
        包名：cn.sirius.nga
        收集个人信息用途/目的：九游广告SDK是广州爱九游信息技术有限公司推出的一个聚合型广告SDK，它为游戏开发人员提供了一种通过在游戏中展示广告来实现收入的方式，主要的广告类型包括：开屏、插屏、横幅、激励视频。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://open.9game.cn/sdkprivacy

        SDK名称：YSDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.ysdk
        收集个人信息用途/目的：YSDK是腾讯应用宝开发团队为移动游戏开发者提供的公共组件和服务库，旨在帮助开发者快速接入腾讯平台，提升游戏接入和上线效率。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://wikinew.open.qq.com/index.html#/iwiki/1308385591

        SDK名称：优量汇 Android SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.qq.e
        收集个人信息用途/目的：提供广告的拉取和展示功能，接入的开发者可获得广告收益。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://e.qq.com/dev/help_detail.html?cid=2005&amp;pid=5983

        SDK名称：游可赢广告SDK（安卓）
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.klevin
        收集个人信息用途/目的：宿主通过接入SDK，获取游可赢平台的广告并处理广告展示及跳转的动作，获取广告收益。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://yky.qq.com/doc/agreement/privacy-policy/

        SDK名称：广点通转化Android SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.qq.gdt.action
        收集个人信息用途/目的：用于广告分析、营销分析等服务的 SDK。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://datanexus.qq.com/doc/develop/compliance/android/privacy_policy

        SDK名称：微信OpenSDK Android
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.mm.opensdk
        收集个人信息用途/目的：提供分享到微信分享、收藏，微信登录、微信支付等功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8

        SDK名称：QQ互联sdk（Android版本）
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.tauth
        收集个人信息用途/目的：QQ互联sdk，帮助手机端App快捷实现QQ帐号登录、分享到QQ等功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e

        SDK名称：QQWalletSDK-Android
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.mobileqq.openpay
        收集个人信息用途/目的：Android端上实现跳转QQ拉起QQ钱包支付功能的工具SDK。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://privacy.qq.com/document/preview/4796a8f96429482293dd15bc17b92c65

        SDK名称：Bugly Android
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.bugly
        收集个人信息用途/目的：监控app的crash、anr问题。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56

        SDK名称：腾讯云HTTP DNS SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent、com.tencent.msdk.dns
        收集个人信息用途/目的：①解析域名
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤传感器信息；
        SDK隐私政策链接： https://wikinew.open.qq.com/index.html#/iwiki/1314826296

        SDK名称：腾讯X5Web SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.xweb
        收集个人信息用途/目的：①为实现为了验证终端用户设备的唯一性，生成唯一标识，须收集App终端用户的AndroidID以及手机型号：②为实现运营商支付和风控功能，须收集App终端用户的手机型号和IP地址；③为实现浏览服务功能，须收集App终端用户的手机型号、SSID（Wi-Fi名称）及BSSID（路由器地址）；
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤传感器信息；
        SDK隐私政策链接： https://wikinew.open.qq.com/index.html#/iwiki/1314826296

        SDK名称：穿山甲广告SDK
        开发者：北京巨量引擎网络技术有限公司
        包名：com.bytedance.sdk.openadsdk
        收集个人信息用途/目的：提供广告变现服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.csjplatform.com/privacy

        SDK名称：融合SDK Android
        开发者：北京巨量引擎网络技术有限公司
        包名：com.bytedance.gromore
        收集个人信息用途/目的：提供开发者流量分配工具、相关数据服务、流量调优策略等。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.csjplatform.com/terms/gromoresdk-privacy

        SDK名称：转化SDK
        开发者：北京巨量引擎网络技术有限公司
        包名：com.bytedance.applog
        收集个人信息用途/目的：用于广告监测归因、投放效果优化等与广告活动相关的使用目的，不对其他第三方提供或披露相关数据。开发者对于相关信息的采集处理存储由开发者自行维护，不经由巨量引擎服务处理。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://open.oceanengine.com/labels/8/docs/1708428054592516

        SDK名称：友盟+移动统计SDK
        开发者：友盟同欣（北京）科技有限公司
        包名：com.umeng.analytics
        服务类型：①统计分析服务；②消息推送服务；③应用崩溃监测服务；
        收集个人信息用途/目的：提供统计分析服务、消息推送服务、应用崩溃监测服务，并通过校准报表数据准确性，提供基础反作弊能力。 收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤获取设备硬件序列号；
        SDK隐私政策链接： https://www.umeng.com/page/policy

        SDK名称：友盟+应用性能监控SDK
        开发者：友盟同欣（北京）科技有限公司
        包名：com.umeng.umcrash
        服务类型：①应用性能监控；
        收集个人信息用途/目的：提供实时、可靠、全面的应用崩溃、ANR、自定义异常等捕获能力，支持多场景、多通道智能告警监控，帮助开发者高效还原崩溃用户的访问路径和业务现场，缩短故障排查时间。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤获取设备硬件序列号；
        SDK隐私政策链接： https://www.umeng.com/page/policy

		开发者：成都惜东网络科技有限公司
		SDK名称：QuickSDK
		产品地址：https://www.quicksdk.com
		隐私协议：https://www.quicksdk.com/base/agreenment/f/private
		涉及个人信息：设备识别码(OAID/IMEI/AndroidID)，应用信息（版本号）、SIM卡信息（包含运行中的进程、MEID、IMSI、设备序列号、设备MAC地址、软件安装列表）、ip信息
		采集方式：SDK本机采集（包含设备上的照片、媒体内容和文件、设备信息、SD卡数据等）
		使用场景：在登录时统一参数唤起分发渠道登录SDK，在支付时统一参数唤起分发渠道支付SDK。
		使用目的：统一分发渠道差异化，使应用可以分发多个渠道

        SDK名称：友盟+消息推送SDK
        开发者：友盟同欣（北京）科技有限公司
        包名：com.umeng.message
        服务类型：①消息推送；
        收集个人信息用途/目的：消息推送组件，提供给用户准时的Push通知功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤获取设备硬件序列号；
        SDK隐私政策链接： https://www.umeng.com/page/policy

        SDK名称：Crash SDK
        开发者：广州市动景计算机科技有限公司
        包名：com.uc.crashsdk
        服务类型：①统计分析服务；②消息推送服务；③应用崩溃监测服务；
        收集个人信息用途/目的：监控SDK的稳定性。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤获取设备硬件序列号；
        SDK隐私政策链接： https://yueying-docs.effirst.com/privacy.html

        SDK名称：图灵盾风险识别SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.turingfd
        收集个人信息用途/目的：①广告推荐、归因及反作弊场景统计，如虚假流量识别等；
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://privacy.qq.com/document/preview/5331f064a91a47eb93993fdacb91c8f7

        SDK名称：Qone SDK
        开发者：深圳市腾讯计算机系统有限公司
        包名：com.tencent.turingfd
        收集个人信息用途/目的：①广告归因，识别黑产和虚假设备；
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://privacy.qq.com/document/preview/1a3015ecc0f240ebad548012fc64b157

        SDK名称：SLS日志采集 Android
        开发者：阿里云计算有限公司
        包名：com.aliyun.sls.android.producer
        收集个人信息用途/目的：日志服务（SLS）是云原生观测分析平台，为Log/Metric/Trace等数据提供大规模、低成本、实时平台化服务。一站式提供数据采集、加工、分析、告警可视化与投递功能，全面提升研发、运维、运营和安全等场景数字化能力。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=a2c4g.11186623.0.0.6a99295aqBPIra

        SDK名称：APP支付客户端SDK
        开发者：支付宝(杭州)信息技术有限公司
        包名：com.alipay
        收集个人信息用途/目的：App 支付适用于商家在 App 应用中集成支付宝支付功能。商家 App 调用支付宝提供的 SDK，SDK 再调用支付宝 App 内的支付模块。如果用户已安装支付宝客户端，商家 App 会跳转到支付宝中完成支付，支付完后跳回到商家 App 内，最后展示支付结果。如果用户没有安装支付宝客户端，商家 App 内会调起支付宝网页支付收银台，用户登录支付宝账号，支付完后展示支付结果。 目前支持手机系统有：iOS（苹果）、Android（安卓）。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96

        SDK名称：TopOn SDK-Android
        开发者：广州塔酷信息科技有限公司
        包名：com.anythink
        收集个人信息用途/目的：SDK支持原生广告(Native,包括自渲染、模板及Draw等形式),激励视频广告(RewardedVideo)，横幅广告(Banner)，插屏广告(Intersitial)和开屏广告(splash)。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://newdocs.toponad.com/docs/1Mn1B7

        SDK名称：Taku Android SDK
        开发者：广州塔酷信息科技有限公司
        包名：com.anythink.sdk.core
        收集个人信息用途/目的：SDK支持原生广告(Native,包括自渲染、模板及Draw等形式),激励视频广告(RewardedVideo)，横幅广告(Banner)，插屏广告(Intersitial)和开屏广告(splash)。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://help.takuad.com/docs/1Mn1B7

        SDK名称：酷盈广告SDK
        开发者：广州数链通信息技术有限公司
        包名；com.smartdicgimkt.sdk
        收集个人信息用途/目的：广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.statisticslinks.com/privacy-policy

        SDK名称：快手联盟（Android）
        开发者：北京快手科技有限公司
        包名：com.kwad.sdk
        收集个人信息用途/目的：快手联盟是移动开发者短视频商业生态联盟，秉持着“视频即服务”的理念，致力于提供创新的短视频/直播商业解决方案，实现用户时长增加、黏性增强，助力用户增长与变现LTV的提升。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://u.kuaishou.com/home/help/detail/1337/1425

        SDK名称：Sigmob SDK-Android
        开发者：北京创智汇聚科技股份有限公司
        包名：com.sigmob.sdk
        收集个人信息用途/目的：向用户展示广告。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://doc.sigmob.com/Sigmob%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97/%E5%90%88%E8%A7%84%E6%9D%A1%E6%AC%BE/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/

        SDK名称：Mintegral Android SDK
        开发者：广州汇世信息科技有限公司
        包名：com.mbridge.msdk
        收集个人信息用途/目的：Mintegral SDK产品，通过集成SDK展示广告创造收益。 Mintegral SDK提供了6种广告形式，包括：Banner(横幅广告)、Native(原生广告,原生视频)、Automatic Rending Native（自动渲染原生广告）、RewardVideo（激励性视频）、Interstitial（新插屏广告）、Splash（开屏广告）。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.mintegral.com/cn/privacy

        SDK名称：百度移动广告SDK
        开发者：北京百度网讯科技有限公司
        包名：com.baidu.mobads.proxy
        收集个人信息用途/目的：百度联盟帮助移动媒体，进行流量变现的SDK。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://union.baidu.com/bqt/#/legal/policies

        SDK名称：oCPC SDK
        开发者：北京百度网讯科技有限公司
        包名：com.baidu.mobads
        收集个人信息用途/目的：提供广告主监控其广告转化的功能。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；⑤获取设备硬件序列号；
        SDK隐私政策链接： https://ocpx-devcenter.bj.bcebos.com/videoworks/console-upload/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E5%BA%94%E7%94%A8SDK%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AA%E5%B7%A5%E5%85%B7%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2022-03-02T07%3A26%3A49Z/-1/host/a457d9fc218b82a94f1a1209ed821931c1f7703ffe40bd220ba25ce5e42f8056

        SDK名称：trackingIO_Android
        开发者：北京热云科技有限公司
        包名：com.reyun.tracking
        收集个人信息用途/目的：TrackingIO Android SDK是TrackingIO通过收集广告主App内各种事件，从而进行广告效果归因和用户行为分析的采集装置。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://new.trackingio.com/#/policy

        SDK名称：引力引擎SDK Android
        开发者：深圳引力引擎科技有限公司
        包名：cn.gravity.android
        收集个人信息用途/目的：引力引擎 SDK 支持代码埋点以及全埋点（无埋点）两种埋点方式来收集广告主App内的各种事件，进而完成广告效果归因和用户行为分析，助力广告主准确做出商业决策。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.gravity-engine.com/h-col-101.html
        使用场景：在用户触发关键行为事件时
        收集方式：sdk采集

        SDK名称：数数科技SDK
        开发者：数数信息科技(上海)有限公司
        包名：cn.thinkingdata.android
        收集个人信息用途/目的：数据统计分析。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://docs-v2.thinkingdata.cn/?version=latest&amp;lan=zh-CN&amp;code=privacy_cn&amp;anchorId=

        SDK名称：TalkingData SDK
        开发者：北京腾云天下科技有限公司
        包名： com.tendcloud.tenddata
        收集个人信息用途/目的：数据统计分析。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.talkingdata.com/sdkprivacy.jsp?languagetype=zh_cn

        SDK名称：Unity 3D SDK
        开发者：Unity Technologies
        包名：
        收集个人信息用途/目的：游戏引擎
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://unity.cn/legal/china-privacy-policy

        SDK名称：Cocos2d
        开发者：厦门雅基软件有限公司
        包名：
        收集个人信息用途/目的：游戏引擎
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html

        SDK名称：zeus基础SDK
        开发者：深圳云步互娱网络科技有限公司
        包名：com.zeus
        收集个人信息用途/目的：账号登录、统计分析服务
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://cdn.yunbugame.com/publishers/docs/base_sdk_privacypolicy.html

        SDK名称：zeus广告SDK
        开发者：深圳云步互娱网络科技有限公司
        包名：com.zeus.ads
        收集个人信息用途/目的：广告聚合平台
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://cdn.yunbugame.com/publishers/docs/ad_sdk_privacypolicy.html

        SDK名称：Chromium
        开发者：Google
        包名：org.chromium
        第三方SDK包名：org.chromium
        收集个人信息用途/目的：加载、渲染Web网页
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；

        SDK名称：移动智能终端补充设备标识体系统一调用SDK
        开发者：中国信息通信研究院
        包名：com.bun.miitmdid
        收集个人信息用途/目的：移动智能终端补充设备标识体系统一调用SDK是支持多厂商的统一的补充设备标识调用SDK，协助移动应用开发者更便捷的访问移动智能终端补充设备标识体系。
        收集个人信息类型：①获取手机设备信息和获取设备序列号（OAID)；
        SDK隐私政策链接： https://www.msa-alliance.cn/col.jsp?id=122

        SDK名称：appsflyer SDK
        开发者：appsflyer
        收集个人信息用途/目的：统计分析服务
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；

        SDK名称：Adjust广告监测SDK
        开发者：艾德贾斯特信息技术（北京）有限公司
        收集个人信息用途/目的：广告投放及数据监测
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；

        SDK名称：网易易盾
        开发者：网易（杭州）网络有限公司
        收集个人信息用途/目的：判断是否存在批量注册、登录等行为，记录账号风险等级信息
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://dun.163.com/clause/privacy

        SDK名称：苹果支付SDK
        开发者：云上艾珀（贵州）技术有限公司
        收集个人信息用途/目的：苹果应用内支付
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；
        SDK隐私政策链接： https://www.icloud.com/gcbd-privacy-policy/

        SDK名称：Volley HTTP library
        开发者：google
        包名：com.android.volley
        收集个人信息用途/目的：http网络请求库
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；

        SDK名称：GameAnalytics Android SDK
        开发者：汇量科技（Mobvista）
        包名：com.gameanalytics.sdk
        收集个人信息用途/目的：广告投放及数据监测
        收集个人信息类型：①获取手机设备信息和获取设备序列号（IMEI/MEID/IMSI/ICCID/GUID/OpenUDID/SSID/BSSID/Android_ID/OAID/VAID/GAID/MAC地址/SN/IP地址/IP地理位置/获取传感器/监听传感器行为）；②文件存储；③获取位置信息；④获取已安装应用列表；⑤获取设备硬件序列号；⑥线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器；

        SDK隐私政策链接： https://www.gameanalytics.com/trust/privacy-notice

        本版发布日期：2023年5月18日
        生效日期：2023年5月18日
    </pre>
  </div>
</template>
